angular.module('gym.components').directive('contactsWidget', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/dashboard/contacts_widget.html.slim'),
    scope: {
      privacyModeEnabled: '=',
      setLastRefreshedTimestamp: '&'
    },
    controller: ["$scope", "$rootScope", "Dashboard", "Members", function($scope, $rootScope, Dashboard, Members) {
      var load;
      $scope.isLoading = true;
      $scope.$on('dashboard:refresh', function() {
        return load();
      });
      load = function() {
        return Dashboard.customGET('contacts').then(function(data) {
          $scope.isLoading = false;
          $scope.data = data;
          return $scope.setLastRefreshedTimestamp({
            timestamp: data.last_cache_refresh
          });
        });
      };
      return load();
    }]
  };
});
